import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import testimonial from '../img/testimonial.png'


export default function Customers(props) {
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    centerMode: true,
    centerPadding :"25%",
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow:1,
          slidesToScroll: 1,
          infinite: true,
          centerPadding :"15%",
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false
        }
      } 
    ]
  };

  const customersData = props && props.customersData;

  return <>
    <div className="sliderOtre overflow-hidden" >
    <Slider {...settings}>
      {customersData && customersData.map((m, i) => {
        return <>
          <div key={i} className="happyBox" >
            <div className="imgT" >
              <img src={testimonial} className="img-fluid" alt="images" />
              <div className="testimonialContent" >
                <h2>{m.title}</h2>
                <p>{m.description}</p>
                <div className="tconetnt_bottom" >
                  <div class="userProfile">
                    <div class="userProfileImg">
                      <img src={m.useravatar} class="img-fluid" alt="user" />
                    </div>
                    <div class="UserLink">
                      <h2>{m.user}</h2>
                      <p>{m.userPost}</p>
                    </div>
                  </div>
                  <div className="starrate" >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M23.6055 8.70885C23.5322 8.49286 23.3972 8.30307 23.2172 8.16292C23.0373 8.02277 22.8202 7.93838 22.5929 7.92018L15.9417 7.39168L13.0635 1.02052C12.9719 0.815315 12.8228 0.641025 12.6342 0.518684C12.4457 0.396343 12.2258 0.331178 12.0011 0.331055C11.7763 0.330932 11.5563 0.395855 11.3677 0.517989C11.179 0.640123 11.0297 0.814249 10.9378 1.01935L8.05968 7.39168L1.40852 7.92018C1.18505 7.93789 0.971409 8.0196 0.793163 8.15554C0.614916 8.29148 0.479607 8.47589 0.403424 8.68672C0.327241 8.89754 0.313409 9.12586 0.363584 9.34434C0.413759 9.56282 0.525816 9.76222 0.686349 9.91868L5.60152 14.7102L3.86318 22.2375C3.8104 22.4654 3.82732 22.7038 3.91174 22.9219C3.99616 23.14 4.14419 23.3278 4.33662 23.4607C4.52905 23.5936 4.75699 23.6657 4.99086 23.6674C5.22474 23.6692 5.45375 23.6007 5.64818 23.4707L12.0007 19.2357L18.3532 23.4707C18.5519 23.6026 18.7863 23.6706 19.0248 23.6653C19.2632 23.6601 19.4944 23.582 19.6871 23.4414C19.8799 23.3009 20.025 23.1047 20.1029 22.8793C20.1808 22.6538 20.1879 22.4099 20.123 22.1803L17.9892 14.7137L23.2812 9.95135C23.6277 9.63868 23.7549 9.15102 23.6055 8.70885Z" fill="#FF9700" />
                    </svg>
                    {m.rating}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      })}
    </Slider>
    </div>
    </>
}